export default [
    {
        path: '/NotificationList',
        name: 'NotificationList',
        title: '申报通知列表',
        component: () => import('@/views/Notification/NotificationList.vue')
    },
    {
        path: '/NotificationDetail',
        name: 'NotificationDetail',
        title: '申报通知详情',
        component: () => import('@/views/Notification/NotificationDetail.vue')
    }
]